import React from "react";
import { useScreenSize } from "hooks";
import DesktopInvoiceCard from "./desktop";
import MobileInvoiceCard from "./mobile";

export default function InvoiceCard() {
  const { isDesktop, isMobile, isTablet } = useScreenSize();

  let InvoiceCardContainer;

  switch (true) {
    case isDesktop:
      InvoiceCardContainer = <DesktopInvoiceCard />;
      break;
    case isTablet:
      InvoiceCardContainer = <DesktopInvoiceCard />;
      break;
    case isMobile:
      InvoiceCardContainer = <MobileInvoiceCard />;
      break;
    default:
      InvoiceCardContainer = <div></div>;
  }

  return InvoiceCardContainer;
}
